import React, { useEffect, useState, useRef } from "react";
import bottiglia from "../../assets/Foto per transizione/P1088476.jpg";
import { Pointer } from "lucide-react";

const Sectionhome5 = () => {
  useEffect(() => {
    const elements = document.querySelectorAll(".moving-paragraph");

    if (elements.length > 0) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("visible");
            } /*  else {
                  entry.target.classList.remove("visible");
                } */
          });
        },
        {
          threshold: 0.3, // La visibilità minima dell'elemento per attivare la transizione
        }
      );

      elements.forEach((element) => observer.observe(element));

      return () => observer.disconnect();
    }
  }, []);
  const handleScroll = (e, target) => {
    e.preventDefault();
    const section = document.querySelector(target);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div>
      <div
        id="volti"
        className="bg-[#191919] bg-opacity-60 gap-x-[10em] flex flex-col md:flex-row-reverse items-center justify-center min-h-[60vh] p-16 text-white"
      >
        {/* Right Section - Text */}
        <div className="md:w-1/2 text-center md:text-left flex flex-col items-center md:items-center md:ml-16 moving-paragraph">
          <p className="mt-4 text-xl md:text-2xl max-w-md text-center leading-relaxed">
            <b>Mario Colonico:</b> "Proporre la massima qualità e conservare un
            paesaggio fatto di territorio e di tradizioni: questa è la mia
            motivazione più grande".
            <br />
          </p>
        </div>

        {/* Left Section - Single Image */}
        <div className="md:w-1/4 flex justify-center mt-6 md:mt-0 moving-paragraph">
          <div className="w-3/4">
            <img
              src={bottiglia}
              alt="Piatto raffinato"
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
      <div
        className="bg-[#191919] bg-opacity-60"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <a
          onClick={(e) => handleScroll(e, "#Home")}
          style={{ cursor: "Pointer" }}
          className="mb-[2%] text-white bg-gradient-to-r from-black via-gray-800 to-black  px-6 py-3 rounded-lg text-xl font-semibold shadow-lg hover:scale-105 transition-transform"
        >
          Torna alla Home
        </a>
      </div>
    </div>
  );
};

export default Sectionhome5;
